<template>
    <div class="alert">
        {{text}}
        <span class="mdi-close"></span>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        props: {
            text: {
                type: String,
                default: 'A generic alert'
            },
            close: {
                type: Boolean,
                default: true
            }
        }
    })
    export default class Alert extends Vue {
        name = 'alert';
    }

    Vue.component(Alert.name, Alert);
</script>



// WEBPACK FOOTER //
// src/components/alerts/Alert.vue